import * as React from "react";
import { useHistory } from "react-router-dom";
import { Form } from "react-bootstrap";

import { useThunkDispatch, organisationResultStore } from "@skv/state";

const OrganisationDirectorySearchForm: React.FC<{}> = () => {
  const history = useHistory();

  const dispatch = useThunkDispatch();

  const [keyword, setKeyword] = React.useState("");

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>): void => {
    e.preventDefault();

    dispatch(
      organisationResultStore.actions.fetchOrganisations({
        keyword,
      })
    ).then((data) => {
      history.push(data.canonicalUrl, {
        searchQuery: {
          keyword,
        },
      });
    });
  };

  const handleChange = (e): void => setKeyword(e.target.value);

  return (
    <form
      method="get"
      action="/volunteering-organisations"
      onSubmit={handleSubmit}
    >
      <div className="form-row align-items-end">
        <div className="col-sm-auto flex-grow-1">
          <Form.Group controlId="q">
            <Form.Label>Search for an organisation</Form.Label>
            <Form.Control
              type="text"
              name="keyword"
              placeholder="Organisation name"
              value={keyword}
              onChange={handleChange}
            />
          </Form.Group>
        </div>
        <div className="col-sm-auto flex-shrink-1 mb-3">
          <button className="btn btn-primary" type="submit">
            Search
          </button>
        </div>
      </div>
    </form>
  );
};

export default OrganisationDirectorySearchForm;
